import { i18n } from '@/i18n';
import {
	getPagesAPI,
	postSortPagesAPI,
	getPageAPI,
	postPageAPI,
	putPageAPI,
	deletePageAPI,
	// page widgets
	postPageWidgetsAPI,
	putPageWidgetsAPI,
	deletePageWidgetsAPI,
	sortPageEidgetsAPI,
	getPageWidgetsAPI,
} from '../../services/api/pages.api';
import {
	getFooterColumnsAPI,
} from '../../services/api/footers.api';
import {
	GET_PAGES_REQUEST,
	GET_PAGES_SUCCESS,
	GET_PAGES_FAILURE,
	SELECT_PAGE,

	GET_PAGE_REQUEST,
	GET_PAGE_SUCCESS,
	GET_PAGE_FAILURE,

	CREATE_PAGE_REQUEST,
	CREATE_PAGE_SUCCESS,
	CREATE_PAGE_FAILURE,

	UPDATE_PAGE_REQUEST,
	UPDATE_PAGE_SUCCESS,
	UPDATE_PAGE_FAILURE,

	DELETE_PAGE_REQUEST,
	DELETE_PAGE_SUCCESS,
	DELETE_PAGE_FAILURE,

	SORT_PAGES_REQUEST,
	SORT_PAGES_SUCCESS,
	SORT_PAGES_FAILURE,

	GET_FOOTER_COLUMNS_REQUEST,
	GET_FOOTER_COLUMNS_SUCCESS,
	GET_FOOTER_COLUMNS_FAILURE,

	// page widgets
	GET_PAGE_WIDGETS_LIST_REQUEST,
	GET_PAGE_WIDGETS_LIST_SUCCESS,
	GET_PAGE_WIDGETS_LIST_FAILURE,

	CREATE_PAGE_WIDGETS_REQUEST,
	CREATE_PAGE_WIDGETS_SUCCESS,
	CREATE_PAGE_WIDGETS_FAILURE,

	UPDATE_PAGE_WIDGETS_REQUEST,
	UPDATE_PAGE_WIDGETS_SUCCESS,
	UPDATE_PAGE_WIDGETS_FAILURE,

	DELETE_PAGE_WIDGETS_REQUEST,
	DELETE_PAGE_WIDGETS_SUCCESS,
	DELETE_PAGE_WIDGETS_FAILURE,

	SORT_PAGE_WIDGETS_REQUEST,
	SORT_PAGE_WIDGETS_SUCCESS,
	SORT_PAGE_WIDGETS_FAILURE,
	// end page widgets

	GET_PAGE_WIDGETS_REQUEST,
	GET_PAGE_WIDGETS_SUCCESS,
	GET_PAGE_WIDGETS_FAILURE,
} from '../types';
import { PAGE_LEVEL } from '../../enums/pages';
import {
	transformedPageList,
	transformedPageDetails,
	transfromedPageSection,
	transfromedPageWidgets,
} from '../../assets/js/transform/pages';
import { pathOr } from '../../assets/js/helpers';
import { transformedWidgetList } from '../../assets/js/transform/widgets';

const getActiveIdsNested = (id = null, level = null) => {
	switch (level) {
		case PAGE_LEVEL.ONE:
			return {
				[PAGE_LEVEL.ONE]: id,
				[PAGE_LEVEL.TWO]: null,
			};

		case PAGE_LEVEL.TWO:
			return {
				[PAGE_LEVEL.TWO]: id,
			};

		default:
			return {};
	}
};

const defaultErrors = {
	slug: false,
};

export default {
	namespaced: true,

	state: {
		list: {
			isLoading: false,
			data: [],
			activeIds: {
				[PAGE_LEVEL.ONE]: null,
				[PAGE_LEVEL.TWO]: null,
			},
		},
		create: {
			isLoading: false,
			error: false,
		},
		edit: {
			isLoading: false,
			isUpdating: false,
			error: false,
			data: {},
		},
		delete: {
			isLoading: false,
			isSuccess: false,
			error: false,
		},
		sort: {
			isLoading: false,
			error: false,
		},
		editAttrStatus: {
			isLoading: false,
			isSuccess: false,
			error: false,
		},
		footerColumn: {
			isLoading: false,
			isError: false,
			data: [],
		},
		listWidget: {
			isLoading: false,
			isSuccess: false,
			error: false,
			data: [],
		},
		createWidget: {
			isLoading: false,
			isSuccess: false,
			error: false,
		},
		editWidget: {
			isLoading: false,
			isSuccess: false,
			error: false,
			data: [],
		},
		deleteWidget: {
			isLoading: false,
			isSuccess: false,
			error: false,
		},
		sortWidget: {
			isLoading: false,
			isSuccess: false,
			error: false,
		},
		pageWidgets: {
			isLoading: false,
			error: false,
			data: [],
		},
	},

	getters: {
		pageList(state) {
			return state.list.data.map(transformedPageList);
		},
		pageDetails(state) {
			return transformedPageDetails(state.edit.data);
		},
	},

	mutations: {
		[GET_PAGES_REQUEST](state) {
			state.list = {
				...state.list,
				isLoading: true,
			};
		},
		[GET_PAGES_SUCCESS](state, { data = [] }) {
			state.list = {
				...state.list,
				isLoading: false,
				data,
			};
		},
		[GET_PAGES_FAILURE](state) {
			state.list = {
				...state.list,
				isLoading: false,
			};
		},
		[GET_PAGE_REQUEST](state) {
			state.edit = {
				...state.edit,
				isLoading: true,
			};
		},
		[GET_PAGE_SUCCESS](state, { data = {} }) {
			state.edit = {
				...state.edit,
				isLoading: false,
				data,
			};
		},
		[GET_PAGE_FAILURE](state) {
			state.edit = {
				...state.edit,
				isLoading: false,
			};
		},
		[SELECT_PAGE](state, { pageId = null, pageLevel = null }) {
			if (pageLevel) {
				state.list = {
					...state.list,
					activeIds: {
						...state.list.activeIds,
						...getActiveIdsNested(pageId, pageLevel),
					},
				};
			}
		},
		[CREATE_PAGE_REQUEST](state) {
			state.create = {
				...state.create,
				isLoading: true,
			};
		},
		[CREATE_PAGE_SUCCESS](state) {
			state.create = {
				...state.create,
				isLoading: false,
				error: false,
				fieldErrors: defaultErrors,
				isSuccess: true,
			};
		},
		[CREATE_PAGE_FAILURE](state) {
			state.create.isLoading = false;
		},
		// Update category
		[UPDATE_PAGE_REQUEST](state) {
			state.edit = {
				...state.edit,
				isUpdating: true,
			};
		},
		[UPDATE_PAGE_SUCCESS](state, { data = {} }) {
			state.edit = {
				...state.edit,
				isUpdating: false,
				error: false,
				data,
			};
		},
		[UPDATE_PAGE_FAILURE](state) {
			state.edit = {
				...state.edit,
				isUpdating: false,
				error: true,
			};
		},
		// Sort
		[SORT_PAGES_REQUEST](state) {
			state.sort = {
				...state.sort,
				isLoading: true,
				error: false,
			};
		},
		[SORT_PAGES_SUCCESS](state, { data = [] }) {
			state.list = {
				...state.list,
				data,
			};
			state.sort = {
				...state.sort,
				isLoading: false,
			};
		},
		[SORT_PAGES_FAILURE](state) {
			state.sort = {
				...state.sort,
				isLoading: false,
				error: true,
			};
		},
		[DELETE_PAGE_REQUEST]() { },
		[DELETE_PAGE_SUCCESS]() { },
		[DELETE_PAGE_FAILURE]() { },
		// footer column
		[GET_FOOTER_COLUMNS_REQUEST](state) {
			state.footerColumn = {
				...state.footerColumn,
				isLoading: true,
				isError: false,
			};
		},
		[GET_FOOTER_COLUMNS_SUCCESS](state, { data = [] }) {
			state.footerColumn = {
				...state.footerColumn,
				data,
				isLoading: false,
			};
		},
		[GET_FOOTER_COLUMNS_FAILURE](state) {
			state.footerColumn = {
				...state.footerColumn,
				isLoading: false,
				isError: true,
			};
		},
		// #regoin page widgets
		[GET_PAGE_WIDGETS_LIST_REQUEST](state) {
			state.listWidget.isLoading = true;
			state.listWidget.isSuccess = false;
			state.listWidget.error = false;
		},
		[GET_PAGE_WIDGETS_LIST_SUCCESS](state, { data = [] }) {
			state.listWidget.isLoading = false;
			state.listWidget.isSuccess = true;
			state.listWidget.error = false;
			state.listWidget.data = data.map((item) => ({
				...transformedWidgetList(item),
				draggable: true,
			}));
		},
		[GET_PAGE_WIDGETS_LIST_FAILURE](state) {
			state.listWidget.isLoading = false;
			state.listWidget.isSuccess = false;
			state.listWidget.error = true;
			state.listWidget.data = [
				...state.listWidget.data,
			];
		},
		[CREATE_PAGE_WIDGETS_REQUEST](state) {
			state.createWidget.isLoading = true;
			state.createWidget.isSuccess = false;
			state.createWidget.error = false;
		},
		[CREATE_PAGE_WIDGETS_SUCCESS](state) {
			state.createWidget.isLoading = false;
			state.createWidget.isSuccess = true;
			state.createWidget.error = false;
		},
		[CREATE_PAGE_WIDGETS_FAILURE](state) {
			state.createWidget.isLoading = false;
			state.createWidget.isSuccess = false;
			state.createWidget.error = true;
		},
		[UPDATE_PAGE_WIDGETS_REQUEST](state) {
			state.editWidget.isLoading = true;
			state.editWidget.isSuccess = false;
			state.editWidget.error = false;
		},
		[UPDATE_PAGE_WIDGETS_SUCCESS](state) {
			state.editWidget.isLoading = false;
			state.editWidget.isSuccess = true;
			state.editWidget.error = false;
		},
		[UPDATE_PAGE_WIDGETS_FAILURE](state) {
			state.editWidget.isLoading = false;
			state.editWidget.isSuccess = false;
			state.editWidget.error = true;
		},
		[DELETE_PAGE_WIDGETS_REQUEST](state) {
			state.deleteWidget.isLoading = true;
			state.deleteWidget.isSuccess = false;
			state.deleteWidget.error = false;
		},
		[DELETE_PAGE_WIDGETS_SUCCESS](state) {
			state.deleteWidget.isLoading = false;
			state.deleteWidget.isSuccess = true;
			state.deleteWidget.error = false;
		},
		[DELETE_PAGE_WIDGETS_FAILURE](state) {
			state.deleteWidget.isLoading = false;
			state.deleteWidget.isSuccess = false;
			state.deleteWidget.error = true;
		},
		[SORT_PAGE_WIDGETS_REQUEST](state) {
			state.sortWidget.isLoading = true;
			state.sortWidget.isSuccess = false;
			state.sortWidget.error = false;
		},
		[SORT_PAGE_WIDGETS_SUCCESS](state) {
			state.sortWidget.isLoading = false;
			state.sortWidget.isSuccess = true;
			state.sortWidget.error = false;
		},
		[SORT_PAGE_WIDGETS_FAILURE](state) {
			state.sortWidget.isLoading = false;
			state.sortWidget.isSuccess = false;
			state.sortWidget.error = true;
		},
		// #endregoin page widgets

		[GET_PAGE_WIDGETS_REQUEST](state) {
			state.pageWidgets = {
				...state.pageWidgets,
				isLoading: true,
				error: null,
			};
		},
		[GET_PAGE_WIDGETS_SUCCESS](state, payload) {
			state.pageWidgets = {
				data: payload,
				isLoading: false,
				error: null,
			};
		},
		[GET_PAGE_WIDGETS_FAILURE](state) {
			state.pageWidgets = {
				...state.pageWidgets,
				isLoading: false,
				error: 'failure to get page widgets api',
			};
		},
	},
	actions: {
		async getPages({ commit }) {
			try {
				commit(GET_PAGES_REQUEST);

				const response = await getPagesAPI();
				const data = pathOr([], ['data', 'data'])(response);
				commit(GET_PAGES_SUCCESS, { data });
			} catch (error) {
				commit(GET_PAGES_FAILURE);

				throw error;
			}
		},
		async getPage({ commit }, id) {
			try {
				commit(GET_PAGE_REQUEST);

				const response = await getPageAPI(id);
				const data = pathOr([], ['data', 'data'])(response);
				commit(GET_PAGE_SUCCESS, { data });
			} catch (error) {
				commit(GET_PAGE_FAILURE);
			}
		},
		selectPage({ commit, state }, { pageId = null, pageLevel = PAGE_LEVEL.ONE }) {
			if (pageId && pageId === state.list.activeIds[pageLevel]) {
				// When select actived item, de-active item
				commit(SELECT_PAGE, { pageId: null, pageLevel });
			} else {
				commit(SELECT_PAGE, { pageId, pageLevel });
			}
		},
		async updateOrderPages({ commit }, pageIds = []) {
			try {
				commit(SORT_PAGES_REQUEST);

				const response = await postSortPagesAPI({
					page_ids: pageIds,
				});
				const data = pathOr([], ['data', 'data'])(response);
				commit(SORT_PAGES_SUCCESS, { data });
			} catch (error) {
				commit(SORT_PAGES_FAILURE);
			}
		},
		async createPage({ commit, dispatch }, params) {
			try {
				commit(CREATE_PAGE_REQUEST);

				await postPageAPI(params);
				commit(CREATE_PAGE_SUCCESS);

				// Show toast
				dispatch('toast/showToast', {
					content: i18n.t('global.successMessageCreate', { type: 'page' }),
					header: i18n.t('global.successMessageTitle'),
					type: 'success',
				}, { root: true });
			} catch (error) {
				commit(CREATE_PAGE_FAILURE, error);


				throw error;
			}
		},
		async updatePage({ commit, dispatch }, { id, params }) {
			try {
				commit(UPDATE_PAGE_REQUEST);

				const response = await putPageAPI(id, params);
				const data = pathOr({}, ['data', 'data'])(response);
				commit(UPDATE_PAGE_SUCCESS, { data });

				dispatch('toast/showToast', {
					content: i18n.t('global.successMessage'),
					header: i18n.t('global.successMessageTitle'),
					type: 'success',
				}, { root: true });

				await dispatch('getPage', id);
			} catch (error) {
				commit(UPDATE_PAGE_FAILURE, error);

				throw error;
			}
		},
		async deletePage({ commit, dispatch }, id) {
			try {
				commit(DELETE_PAGE_REQUEST);

				await deletePageAPI(id);
				commit(DELETE_PAGE_SUCCESS);

				dispatch(
					'toast/showToast',
					{
						content: i18n.t('global.successMessageDelete', { type: 'Page' }),
						header: i18n.t('global.successMessageTitleDelete'),
					},
					{ root: true },
				);
			} catch (error) {
				commit(DELETE_PAGE_FAILURE);

				throw error;
			}
		},

		async getFooterColumns({ commit }) {
			try {
				commit(GET_FOOTER_COLUMNS_REQUEST);

				const response = await getFooterColumnsAPI();
				const data = pathOr([], ['data', 'data'])(response);
				commit(GET_FOOTER_COLUMNS_SUCCESS, { data: transfromedPageSection(data) });
			} catch (error) {
				commit(GET_FOOTER_COLUMNS_FAILURE);

				throw error;
			}
		},

		// #regoin page widgets
		async getPageWidgetsProduct({ commit }) {
			try {
				commit(GET_PAGE_WIDGETS_REQUEST);

				const response = await getPageWidgetsAPI({
					type: 'product',
					per_page: 'all',
				});
				const data = pathOr([], ['data', 'data'])(response);
				commit(GET_PAGE_WIDGETS_SUCCESS, transfromedPageWidgets(data));
			} catch (error) {
				commit(GET_PAGE_WIDGETS_FAILURE);

				throw error;
			}
		},
		async getPageWidgetList({ commit }, params = {}) {
			try {
				commit(GET_PAGE_WIDGETS_LIST_REQUEST);
				const response = await getPageWidgetsAPI(params);
				const data = pathOr([], ['data', 'data'])(response);
				commit(GET_PAGE_WIDGETS_LIST_SUCCESS, { data });
			} catch (error) {
				commit(GET_PAGE_WIDGETS_LIST_FAILURE);
			}
		},
		async createPageWidgets({ commit, dispatch }, params) {
			try {
				commit(CREATE_PAGE_WIDGETS_REQUEST);
				await postPageWidgetsAPI(params);
				commit(CREATE_PAGE_WIDGETS_SUCCESS);

				// Show toast
				dispatch('toast/showToast', {
					content: i18n.t('global.successMessageCreate', { type: 'Widget' }),
					header: i18n.t('global.successMessageTitle'),
					type: 'success',
				}, { root: true });
			} catch (error) {
				commit(CREATE_PAGE_WIDGETS_FAILURE, error);
			}
		},
		async updatePageWidgets({ commit, dispatch }, { id, params }) {
			try {
				commit(UPDATE_PAGE_WIDGETS_REQUEST);
				await putPageWidgetsAPI(id, params);
				commit(UPDATE_PAGE_WIDGETS_SUCCESS);

				// Show toast
				dispatch('toast/showToast', {
					content: i18n.t('global.successMessage', { type: 'Widget' }),
					header: i18n.t('global.successMessageTitle'),
					type: 'success',
				}, { root: true });
			} catch (error) {
				commit(UPDATE_PAGE_WIDGETS_FAILURE);


				throw error;
			}
		},
		async deletePageWidgets({ commit, dispatch }, id) {
			try {
				commit(DELETE_PAGE_WIDGETS_REQUEST);
				await deletePageWidgetsAPI(id);
				commit(DELETE_PAGE_WIDGETS_SUCCESS);

				// Show toast
				dispatch('toast/showToast', {
					content: i18n.t('global.successMessageDelete', { type: 'Widget' }),
					header: i18n.t('global.successMessageTitleDelete'),
					type: 'success',
				}, { root: true });
			} catch (error) {
				commit(DELETE_PAGE_WIDGETS_FAILURE);


				throw error;
			}
		},
		async sortPageWidgets({ commit }, params) {
			try {
				commit(SORT_PAGE_WIDGETS_REQUEST);
				await sortPageEidgetsAPI(params);
				commit(SORT_PAGE_WIDGETS_SUCCESS);
			} catch (error) {
				commit(SORT_PAGE_WIDGETS_FAILURE);


				throw error;
			}
		},
		// #endregoin page widgets
	},
};
